import * as types from "../actions/types";

const initialState = {
    pageNumber: 0,
    pageCount: 0,
    count: 0,

    list: [],
    list_loading: false,
    item: {},
    item_loading: false,
    attrs: null,
    attrs_loading: false
};

export default function categories(state = initialState, action) {
    switch (action.type) {
        case types.SET_CATEGORIES:
            return {
                ...state,
                list: action.payload
            };
        case types.SET_CATEGORIES_PAGE:
            return {
                ...state,
                ...action.payload
            };
        case types.SET_CATEGORIES_LOADING:
            return {
                ...state,
                list_loading: action.payload
            };
        case types.SET_CATEGORY:
            return {
                ...state,
                item: action.payload,
            };
        case types.SET_CATEGORY_LOADING:
            return {
                ...state,
                item_loading: action.payload
            };
        case types.SET_CATEGORY_ATTRS:
            return {
                ...state,
                attrs: action.payload,
            };
        case types.SET_CATEGORY_ATTRS_LOADING:
            return {
                ...state,
                attrs_loading: action.payload,
            };
        default:
            return state;
    }
}